module.exports = __webpack_public_path__ + "img/img6702.9b0d86cb.jpg";